export default __webpack_public_path__ + "static/media/boxer.73259681.png";